import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store/index'

Vue.use(VueRouter)

const routes = [
  {
    path: '',
    component: () => import('@/layouts/Main'),
    children: [
      {
        path: '/',
        redirect: '/dashboard'
      },
      // Dashboard
      {
        name: 'Dashboard',
        path: 'dashboard',
        component: () => import('@/views/Dashboard'),
        meta: {auth: true},
      },
      {
        name: 'Session limits',
        path: 'session-limits',
        component: () => import('@/views/session-limits/Index'),
        meta: {auth: true},
      },
      {
        name: 'Profile',
        path: 'profile',
        component: () => import('@/views/profile/Index'),
        meta: {auth: true},
      },
      {
        name: 'Working Hours',
        path: 'working-hours',
        component: () => import('@/views/personal_calendar/WorkingHours'),
        meta: {auth: true},
      },
      {
        name: 'Calendar',
        path: 'calendar',
        component: () => import('@/views/personal_calendar/Calendar'),
        meta: {auth: true},
      },
      {
        name: 'Booking',
        path: 'booking',
        component: () => import('@/views/booking/Index'),
        meta: {auth: true},
      },
      {
        name: 'Classroom',
        path: 'classroom',
        component: () => import('@/views/classroom/Classroom'),
        meta: {auth: true},
      },
      {
        name: 'Classroom session',
        path: 'classroom/:session_id',
        component: () => import('@/views/classroom/Session'),
        props: true,
        meta: {auth: true},
      },
      {
        name: 'General schedule',
        path: 'general-schedule',
        component: () => import('@/views/general_schedule/Index'),
        meta: {auth: true},
      },
      {
        name: 'Study cycles',
        path: 'study-cycles',
        component: () => import('@/views/study_cycles/Index'),
        meta: {auth: true},
      },
      {
        name: 'Sessions',
        path: 'sessions',
        component: () => import('@/views/sessions/Sessions'),
        props: true,
        meta: {auth: true},
      },
      {
        name: 'Create session',
        path: 'sessions/create',
        component: () => import('@/views/sessions/Create'),
        props: true,
        meta: {auth: true},
      },
      {
        name: 'Session',
        path: 'sessions/:session_id',
        component: () => import('@/views/sessions/Session'),
        props: true,
        meta: {auth: true},
        redirect: 'sessions/:session_id/info',
        children: [
          {
            name: 'Session info',
            path: 'info',
            component: () => import('@/views/sessions/Info'),
            meta: {auth: true},
          },
          {
            name: 'Session response',
            path: 'response',
            component: () => import('@/views/sessions/Response'),
            meta: {auth: true},
          },
          {
            name: 'Session edit',
            path: 'edit',
            component: () => import('@/views/sessions/Edit'),
            meta: {auth: true},
          },
          {
            name: 'Session reschedule',
            path: 'reschedule',
            component: () => import('@/views/sessions/Reschedule'),
            meta: {auth: true},
          },
          {
            name: 'Session children',
            path: 'children',
            component: () => import('@/views/sessions/Children'),
            meta: {auth: true},
          },
        ]
      },

      {
        name: 'Invoices',
        path: 'invoices',
        component: () => import('@/views/invoices/Invoices'),
        meta: {auth: true},
      },

      {
        name: 'Study groups',
        path: 'study-groups',
        component: () => import('@/views/study_groups/Index'),
        meta: {auth: true},
      },
      {
        name: 'Create study group',
        path: 'study-groups/create',
        component: () => import('@/views/study_groups/Create'),
        meta: {auth: true},
      },
      {
        name: 'Study group',
        path: 'study-groups/:study_group_id',
        component: () => import('@/views/study_groups/study_group/Index'),
        meta: {auth: true},
        redirect: 'study-groups/:study_group_id/main',
        children: [
          {
            name: 'Study group main',
            path: 'main',
            component: () => import('@/views/study_groups/study_group/Main'),
            meta: {auth: true},
          },
          {
            name: 'Study group join',
            path: 'join',
            component: () => import('@/views/study_groups/study_group/Join'),
            meta: {auth: true},
          },
          {
            name: 'Study group booking policy',
            path: 'booking-policy',
            component: () => import('@/views/study_groups/study_group/BookingPolicy'),
            meta: {auth: true},
          },
          {
            name: 'Study group chat',
            path: 'chat',
            component: () => import('@/views/study_groups/study_group/Chat'),
            meta: {auth: true},
          },
          {
            name: 'Edit study group',
            path: 'edit',
            component: () => import('@/views/study_groups/study_group/Edit'),
            meta: {auth: true},
          },
          {
            name: 'Edit study members',
            path: 'members',
            component: () => import('@/views/study_groups/study_group/Members'),
            meta: {auth: true},
          },
          {
            name: 'Edit study invite members',
            path: 'members/invite',
            component: () => import('@/views/study_groups/study_group/Invite'),
            meta: {auth: true},
          },
          {
            name: 'Study subgroups',
            path: 'sub-groups',
            component: () => import('@/views/study_groups/study_group/SubGroups'),
            meta: {auth: true},
          },
          {
            name: 'Study group schedule',
            path: 'schedule',
            component: () => import('@/views/study_groups/study_group/Schedule'),
            meta: {auth: true},
          },
        ]
      },

      {
        name: 'Tutors',
        path: 'tutors',
        component: () => import('@/views/members/Tutors'),
        meta: {auth: true},
      },
      {
        name: 'Tutor',
        path: 'tutors/:tutor_id',
        component: () => import('@/views/members/tutor/Index'),
        meta: {auth: true},
        redirect: 'tutors/:tutor_id/info',
        children: [
          {
            name: 'Tutor info',
            component: () => import('@/views/members/tutor/Info'),
            path: 'info'
          },
          {
            name: 'Tutor edit',
            component: () => import('@/views/members/tutor/Edit'),
            path: 'edit'
          },
          {
            name: 'Tutor working hours',
            component: () => import('@/views/members/tutor/WorkingHours'),
            path: 'working-hours'
          },
          {
            name: 'Tutor sessions',
            component: () => import('@/views/members/tutor/Sessions'),
            path: 'sessions'
          },
          {
            name: 'Tutor payments',
            component: () => import('@/views/members/tutor/Payments'),
            path: 'payments'
          },
          {
            name: 'Tutor limits',
            path: 'limits',
            component: () => import('@/views/members/tutor/Limits')
          },
          {
            name: 'Tutor events',
            component: () => import('@/views/members/tutor/Events'),
            path: 'events'
          },
          {
            name: 'Tutor reviews',
            component: () => import('@/views/members/tutor/Reviews'),
            path: 'reviews'
          },
        ]
      },


      {
        name: 'Students',
        path: 'students',
        component: () => import('@/views/members/Students'),
        meta: {auth: true},
      },
      {
        name: 'Student',
        path: 'students/:student_id',
        component: () => import('@/views/members/student/Index'),
        meta: {auth: true},
        redirect: 'students/:student_id/info',
        children: [
          {
            name: 'Student info',
            path: 'info',
            component: () => import('@/views/members/student/Info'),
            meta: {auth: true},
          },
          {
            name: 'Student edit',
            path: 'edit',
            component: () => import('@/views/members/student/Edit')
          },
          {
            name: 'Student limits',
            path: 'limits',
            component: () => import('@/views/members/student/Limits')
          },
          {
            name: 'Student sessions',
            path: 'sessions',
            component: () => import('@/views/members/student/Sessions')
          },
          {
            name: 'Student events',
            path: 'events',
            component: () => import('@/views/members/student/Events')
          },
          {
            name: 'Student invoices',
            path: 'invoices',
            component: () => import('@/views/members/student/Invoices')
          },
          {
            name: 'Student study groups',
            path: 'study-groups',
            component: () => import('@/views/members/student/StudyGroups')
          },
        ]
      },

      {
        name: 'Practice areas',
        path: 'practice-areas',
        component: () => import('@/views/services/PracticeAreas'),
        meta: {auth: true},
      },
      {
        name: 'Session types',
        path: 'session-types',
        component: () => import('@/views/services/SessionTypes'),
        meta: {auth: true},
      },
      {
        name: 'Mocks',
        path: 'mocks',
        component: () => import('@/views/services/Mocks'),
        meta: {auth: true},
      },
      {
        name: 'Mock',
        path: 'mocks/:mock_id',
        component: () => import('@/views/services/mock/Index'),
        meta: {auth: true},
        redirect: 'mocks/:mock_id/edit',
        children: [
          {
            name: 'Mock edit',
            path: 'edit',
            component: () => import('@/views/services/mock/Edit'),
            meta: {auth: true},
          },
          {
            name: 'Mock scenario',
            path: 'scenario',
            component: () => import('@/views/services/mock/Scenario'),
            meta: {auth: true},
          },
          {
            name: 'Mock marksheet',
            path: 'marksheet',
            component: () => import('@/views/services/mock/Marksheet'),
            meta: {auth: true},
          },
          {
            name: 'Mock instructions',
            path: 'instructions',
            component: () => import('@/views/services/mock/Instructions'),
            meta: {auth: true},
          },
          {
            name: 'Mock materials',
            path: 'materials',
            component: () => import('@/views/services/mock/Materials'),
            meta: {auth: true},
          },
          {
            name: 'Mock extra tasks',
            path: 'extra-tasks',
            component: () => import('@/views/services/mock/ExtraTasks'),
            meta: {auth: true},
          },
          {
            name: 'Mock answer templates',
            path: 'answer-templates',
            component: () => import('@/views/services/mock/AnswerTemplates'),
            meta: {auth: true},
          }, {
            name: 'Mock reviews',
            path: 'reviews',
            component: () => import('@/views/services/mock/Reviews'),
            meta: {auth: true},
          },
        ]
      },
      {
        name: 'Packages',
        path: 'packages',
        component: () => import('@/views/services/Packages'),
        meta: {auth: true},
      },


      {
        name: 'Payments',
        path: 'payments',
        component: () => import('@/views/payments/Payments'),
        meta: {auth: true},
      },
      {
        name: 'Settings',
        path: 'settings',
        component: () => import('@/views/services/Settings'),
        meta: {auth: true},
      },

    ],
  },
  {
    path: '',
    component: () => import('@/layouts/Authentication'),
    children: [
      {
        name: 'Login',
        path: 'login',
        component: () => import('@/views/authentication/Login'),
      },
      {
        name: 'Register',
        path: 'register',
        component: () => import('@/views/authentication/Register'),
      },
      {
        name: 'Verify Email',
        path: 'verify-email',
        component: () => import('@/views/authentication/Verify'),
      },
      {
        name: 'Forgot Password',
        path: 'forgot-password',
        component: () => import('@/views/authentication/ForgotPassword'),
      },
      {
        name: 'Reset Password',
        path: 'reset-password',
        component: () => import('@/views/authentication/ResetPassword'),
      },

      {
        name: 'E503',
        path: '503',
        component: () => import('@/views/authentication/503'),
      },
      {
        name: 'E404',
        path: '*',
        component: () => import('@/views/authentication/404'),
      },
    ],
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeResolve((to, from, next) => {
  if (to.matched.some(record => record.meta.auth)) {
    if (!store.getters['getAuthToken']) {
      next({ name: 'Login' })
      return;
    }
  }
  next()
})

router.onError((error) => {
  if (error.message.match(/Loading chunk (\d)+ failed/g) && navigator.onLine) {
    router.replace(router.history.pending.fullPath);
  }
});

export default router
